import setPagesInNavigation from './set-pages-in-navigation';
import setMultilingual from './set-multilingual';
import addUsedCustomColor from './add-used-custom-color';
import deleteUsedCustomColor from './delete-used-custom-color';
import createPageFromTemplate from './create-page-from-template';
import setActivePage from './set-active-page';
import reloadSiteMeta from './reload-site-meta';

export default {
  setPagesInNavigation,
  setMultilingual,
  addUsedCustomColor,
  deleteUsedCustomColor,
  createPageFromTemplate,
  setActivePage,
  reloadSiteMeta,
};
